import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudDeposits = () => import('./staff/crudDeposits')
const ViewStaffCrudDepositsOperations = () => import('./staff/crudOperations')
const ViewStaffCrudDepositsQuery = () => import('./staff/crudQuery')
const ViewStaffCrudDepositsQueryLocations = () => import('./staff/crudQueryLocations')
const ViewStaffCrudDepositsStockCount = () => import('./staff/stockCount')
const ViewStaffCrudStockControl = () => import('./staff/crudStockControl')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'DepositsStaffDashboard',
  crudDeposits: 'DepositsStaffCrudDeposits',
  crudDepositsQuery: 'DepositsStaffCrudDepositsQuery',
  crudDepositsOperations: 'DepositsStaffCrudDepositsOperations',
  crudDepositsQueryByLocations: 'DepositsStaffCrudDepositsQueryLocations',
  crudDepositsStockCount: 'DepositsStaffCrudDepositsStockCount',
  crudDepositsStockControl: 'DepositsStaffCrudDepositsStockControl',
}

const router =
  [
    {
      path: '/st/deposits',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Depósitos',
          }          
        },        
        {
          path: 'deposits',
          name: VIEWS.crudDeposits,
          component: ViewStaffCrudDeposits,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Depósitos',
          }          
        },
        {
          path: 'deposits-query',
          name: VIEWS.crudDepositsQuery,
          component: ViewStaffCrudDepositsQuery,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Stock por Producto',
          }          
        },             
        {
          path: 'deposits-operations',
          name: VIEWS.crudDepositsOperations,
          component: ViewStaffCrudDepositsOperations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Operaciones de Depósitos',
          }          
        },    
        {
          path: 'deposits-query-locations',
          name: VIEWS.crudDepositsQueryByLocations,
          component: ViewStaffCrudDepositsQueryLocations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Stock por Ubicación',
          }
        },
        {
          path: 'stock-count',
          name: VIEWS.crudDepositsStockCount,
          component: ViewStaffCrudDepositsStockCount,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recuento de Stock',
          }
        },
        {
          path: 'stock-control',
          name: VIEWS.crudDepositsStockControl,
          component: ViewStaffCrudStockControl,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Control de Stock por Producto',
          }
        },
      ]
    },

    {
      path: '/cu/deposits',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/deposits',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
